<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="calibre2"><span id="Page_32" title="[Pg 32]"></span></p>
<h2 class="nobreak" id="CHAPTER_IV">CHAPTER IV<br class="calibre4"/>
<span class="fs3">MR. POTT GOES AWAY</span></h2>
</div>
<p class="calibre2">Keeping Bunny and Sue in the background,
Mr. and Mrs. Brown looked in the room
where Uncle Tad was watching over Mr.
Pott.</p>
<p class="calibre2">“Is anything the matter?” whispered Mrs.
Brown, for when she and her husband looked
in the room the injured man seemed to be
quiet and there was no longer the murmur of
voices.</p>
<p class="calibre2">“He’s all right now,” said Uncle Tad in low
tones. “But he was a bit restless a moment
ago. He was sort of talking in his sleep, I
guess, about his missing son and the lost treasure.”</p>
<p class="calibre2">“Do you really think he lost a treasure?”
asked Mr. Brown.</p>
<p class="calibre2">“Well,” said Uncle Tad slowly, “you know
how it is with sick folks. Sometimes they<span id="Page_33" title="[Pg 33]"></span>
imagine things. I know how it was in the
army. Sometimes the men that were hurt
would talk a lot about things that had never
happened. They were wandering in their
minds.”</p>
<p class="calibre2">“But Mr. Pott lost his son—he told us so,”
remarked Bunny. He and Sue stood just outside
the door.</p>
<p class="calibre2">“Yes,” agreed Sue, “he did. When he fell
off the horse and came into our yard and sat
on the pile of grass, he said he’d lost his
son.”</p>
<p class="calibre2">“Well, maybe he did, and a treasure, too,”
agreed Mr. Brown. “Perhaps in the morning
he’ll be better able to tell us more about himself
and how he happened to come here.”</p>
<p class="calibre2">“He came here because he heard there was
a sailor living here,” explained Mrs. Brown.
“He thought it might be his son who had been
rescued from the wreck of the <em class="calibre6">Mary Bell</em>.
But the only sailor we have here is Jed Winkler.”</p>
<p class="calibre2">“And he’s too old to have been this man’s
son,” said Mr. Brown.</p>
<p class="calibre2">The sick man had grown quiet again, and<span id="Page_34" title="[Pg 34]"></span>
Mrs. Brown sent Julia, the maid, in to watch
by his couch while Uncle Tad had a rest.</p>
<p class="calibre2">The excitement caused by the runaway
horse had passed, the animal having been
taken back to the livery stable where Mr. Pott
had hired it. Bunker Blue raked up the pile
of grass and put it back of the Brown garage
where later some stray goats came and ate
it.</p>
<p class="calibre2">Bunny and Sue, forgetting for a time about
the strange sailor in their house, ran out to
play again.</p>
<p class="calibre2">“But don’t let’s play store again,” suggested
Bunny.</p>
<p class="calibre2">“What’ll we play?” Sue wanted to know.</p>
<p class="calibre2">“Let’s play about the rolling ocean,” suggested
Bunny, whose mind seemed filled with
thoughts of the great sea. “We’ll make believe
the store counter is a ship, and I’ll be the captain
and you can be a passenger and we’ll go
to the West Indies.”</p>
<p class="calibre2">“And maybe we’ll find Mr. Pott’s lost son,”
added Sue.</p>
<p class="calibre2">“I’d rather find the treasure,” said Bunny
Brown.</p>
<p class="calibre2"><span id="Page_35" title="[Pg 35]"></span></p>
<p class="calibre2">Neither he nor his sister dreamed of the
strange adventures that were soon to be theirs.</p>
<p class="calibre2">Bunny and Sue so often made believe that
it did not take them long to change the “store”
into an ocean-going steamer. The long plank
that had served for a counter was laid on two
lower boxes, for, as it was, it was too high for
the deck of a ship. Then Bunny placed one
box up in front of the plank.</p>
<p class="calibre2">“This is where the captain steers the ship,”
he said.</p>
<p class="calibre2">He placed another box behind the first at
the farther end of the plank.</p>
<p class="calibre2">“That’s the cabin for passengers,” he told
Sue. “You get in there, and be careful you
don’t fall into the water.”</p>
<p class="calibre2">“I don’t see any water,” remarked Sue.</p>
<p class="calibre2">“You don’t?” cried Bunny Brown. “Why,
there’s water all around us! How do you
s’pose a ship’s going to sail on the rolling
ocean if it doesn’t go in the water? This grass
all around us is water, and you’d better get on
board else you’ll be drowned. You’re in the
water now!” and he pointed to Sue’s feet.</p>
<p class="calibre2">“I am not in the water!” she cried.</p>
<p class="calibre2"><span id="Page_36" title="[Pg 36]"></span></p>
<p class="calibre2">“You are so!” asserted Bunny. “And if you
don’t get on board quick, the steamer’ll go off
without you! Toot! Toot!” and he pretended
to blow a whistle.</p>
<p class="calibre2">“Then you’re in the water, too,” retorted
Sue, pointing to Bunny’s feet which were also
on the grass.</p>
<p class="calibre2">“Oh, well, that’s nothing! Captains have to
be in the water! Anyhow, I’m going to get
up and steer the boat. So if you want to play
you’ve got to get on, too.”</p>
<p class="calibre2">Bunny made a jump and landed on the
plank. Then he took his place in the forward
box. Sue was going to get aboard when she
happened to think of something.</p>
<p class="calibre2">“Bunny,” she called.</p>
<p class="calibre2">“I’m not Bunny!” he answered. “I’m Captain
Ward.” He remembered the name of the
commander of the <em class="calibre6">Beacon</em> spoken of by Mr.
Brown. “You have to call me Captain Ward
if you’re going to play steamboat,” he told his
sister.</p>
<p class="calibre2">“All right. Captain Ward,” and Sue did
not smile when she said this, “could I take one
of my dolls on your steamer?”</p>
<p class="calibre2"><span id="Page_37" title="[Pg 37]"></span></p>
<p class="calibre2">“Doll? No!” cried Bunny. “You’re supposed
to be a big woman passenger and they
don’t have dolls. But if you want to take your
little girl in your cabin, you can do that.”</p>
<p class="calibre2">“Oh, all right, Captain Ward. Thank
you,” quickly answered Sue, understanding
what Bunny meant. If you were pretending,
you must do it in everything. And since she
was pretending to be a grown-up passenger
she would not, naturally, have a doll. But
she could make believe her doll was her little
girl. “I’ll go and get my daughter now.” She
had already taken her place on the “ship,” but
now, as she was about to get off, she remembered
that the grass was “water.”</p>
<p class="calibre2">“How am I going to get my daughter?” she
asked. “I can’t jump into the ocean to go for
her,” and she pointed to the grass.</p>
<p class="calibre2">“That’s so,” agreed Bunny. “Wait! I’ll
steer the ship up to the pier and you can go
ashore there and get your daughter. Look
out now, hold tight! We’re going fast!
Toot! Toot!”</p>
<p class="calibre2">Sue held “tight,” and though of course the
plank and the boxes did not move from the<span id="Page_38" title="[Pg 38]"></span>
place where they had formerly been part of
the “store,” still to the children it was as if
they were sailing on the rolling ocean.</p>
<p class="calibre2">“Whoa!” suddenly called Bunny. “We’re
at the pier now,” he added to his sister. “You
can go ashore and get your doll—I mean your
daughter,” he quickly corrected himself.</p>
<p class="calibre2">Sue began to laugh.</p>
<p class="calibre2">“What’s the matter?” asked Bunny. He
did not like to have his sister laugh when he
was pretending in real earnest.</p>
<p class="calibre2">“Ho! Ho!” laughed Sue. “You told the
ship to whoa like a horse. You shouldn’t say
whoa to a ship. You’ve got to tell it to halt,
Bunny Brown.”</p>
<p class="calibre2">Then Bunny saw he had made a mistake.
But in turn he laughed at Sue.</p>
<p class="calibre2">“You don’t say halt to a ship,” he declared.
“You only say halt to soldiers, and we aren’t
playing soldiers.”</p>
<p class="calibre2">“Well, anyhow, you don’t say whoa to a
ship,” declared Sue.</p>
<p class="calibre2">“No, I guess you don’t,” admitted Bunny.
“Well, anyhow, the ship has stopped and
we’re at Pier Number Three and you can go<span id="Page_39" title="[Pg 39]"></span>
ashore without getting in the water now and
bring your daughter on board,” he said.</p>
<p class="calibre2">“All right,” Sue agreed.</p>
<p class="calibre2">So she again stepped in the grass, but this
time it was not water, but the floor boards of
the pier, so of course she could not get wet.
Up to the house she ran to get one of her dolls,
and soon she was back on board the <em class="calibre6">Beacon</em>.
She found Bunny making a loud hissing noise.</p>
<p class="calibre2">“What you doing?” Sue asked. “Are you
playing wild animals? You sound like a
snake. I don’t want to play wild animals. I
want to play ship.”</p>
<p class="calibre2">“I am playing ship,” declared Bunny. “I’m
the engine blowing off steam. Don’t you know
steam when you hear it?”</p>
<p class="calibre2">“Oh, if it’s steam, all right,” agreed Sue. “I
thought you were a snake.”</p>
<p class="calibre2">“All aboard!” cried Bunny Brown. “Toot!
Toot! All aboard!”</p>
<p class="calibre2">Again Sue stepped on the grass, which was
not water because it was a pier, and soon she
was in her box cabin.</p>
<p class="calibre2">Bunny started the ship off once more, hissing
to show that steam was blowing out of the<span id="Page_40" title="[Pg 40]"></span>
pipes and now and then whistling to tell other
ships to get out of his path.</p>
<p class="calibre2">Sue held her “daughter” in her arms and
pretended to show her whales and sharks as
they sailed along the grassy-green rolling
ocean.</p>
<p class="calibre2">Pretty soon Bunny left his place in the forward
box and walked back along the plank
toward his sister Sue. Bunny held out his
hand to Sue as if he wanted something.</p>
<p class="calibre2">“What do you want, Captain Ward?” asked
the little girl.</p>
<p class="calibre2">“I’m not Captain Ward now,” Bunny answered.
“I’m the conductor and I want your
ticket.”</p>
<p class="calibre2">“They don’t have conductors on ships,” retorted
Sue. “They have conductors on trolley
cars and steam cars.”</p>
<p class="calibre2">“Well, I’m the ticket-taker, anyhow, and
you’ve got to give me a ticket or I’ll put you
off the ship,” announced Bunny.</p>
<p class="calibre2">“Oh, all right, I’ll give you a ticket,” agreed
Sue.</p>
<p class="calibre2">She put her hand in her pocket and pulled
out one of the green leaves which a little while<span id="Page_41" title="[Pg 41]"></span>
before she had used as money when she and
Bunny were playing store.</p>
<p class="calibre2">“There’s my ticket,” said the little girl.</p>
<p class="calibre2">“Yes,” agreed her brother, looking closely
at it, “I see it’s a ticket all right. You’re going
to the West Indies, aren’t you?”</p>
<p class="calibre2">“Yes,” replied Sue, “to the West Indies.”</p>
<p class="calibre2">Bunny punched the ticket by putting a hole
in the leaf with a small twig. Then he held
out his hand again.</p>
<p class="calibre2">“What you want now?” asked Sue. “I gave
you my ticket.”</p>
<p class="calibre2">“I must have a ticket for that child,” said
Bunny sternly. “She’s more’n five years old.”</p>
<p class="calibre2">Once he had been on a street car with his
mother and he had heard the conductor say
this to a woman with a little girl.</p>
<p class="calibre2">“Yes, Annabell is more’n five years old,”
Sue said. “But I didn’t know I had to have a
ticket for her.”</p>
<p class="calibre2">“Well, you have to,” declared Bunny.</p>
<p class="calibre2">“Oh, all right,” agreed Sue, and she handed
out another green leaf.</p>
<p class="calibre2">Bunny tore the leaf in two and gave Sue
back a part of it.</p>
<p class="calibre2"><span id="Page_42" title="[Pg 42]"></span></p>
<p class="calibre2">“What’s this for—my change?” she asked.</p>
<p class="calibre2">“It takes only a half ticket for little girls,”
announced Bunny, as he punched half the leaf
with his twig-puncher. “I hope you have a
nice trip to the West Indies,” he said to passenger
Sue.</p>
<p class="calibre2">“I hope so,” echoed the little girl. “Do you
think it will be very rough on the rolling
ocean, Captain Ward?” she asked, for now
Bunny, being back in his steering box, was in
command of the ship.</p>
<p class="calibre2">“Yes, we may have a very bad storm,” he
said. “But don’t be afraid, Mrs. Anderson,
I’ll bring you and your daughter safe to the
West Indies.”</p>
<p class="calibre2">“I’m glad of that,” returned Sue politely.</p>
<p class="calibre2">So the children played, having much fun on
the “steamboat” they had made so simply out
of a plank and some boxes. They sailed to the
West Indies and back. Then they made a trip
to the north pole, and, landing there, Bunny
and Sue, though under an apple tree, played
they were in one of the igloos, or snow huts,
of the Eskimos.</p>
<p class="calibre2">All the rest of the day the children played<span id="Page_43" title="[Pg 43]"></span>
at one game or another, and when night came
they were tired and ready to go to sleep.</p>
<p class="calibre2">“Is Mr. Pott any worse?” asked Bunny, as
he and Sue were getting ready for bed that
night.</p>
<p class="calibre2">“No, I think he isn’t any worse,” his mother
answered. “But he doesn’t seem to be any better,
either. Dr. Rudd, who was here a while
ago, will see him again in the morning.”</p>
<p class="calibre2">“He didn’t find his lost son or the treasure,
did he?” Sue wanted to know.</p>
<p class="calibre2">“No, dear. Now go to bed and don’t think
any more about it.”</p>
<p class="calibre2">“I’m going to think of the fun we’ll have on
the rolling ocean,” said Bunny Brown.</p>
<p class="calibre2">“So’m I,” murmured his sister Sue.</p>
<p class="calibre2">“Yes, that will be best,” their mother told
them.</p>
<p class="calibre2">The children looked in at Mr. Pott the next
morning, but he lay with eyes closed and did
not see them. Then Bunny and Sue went to
the store for their mother. They were gone
about an hour. When they came back they
saw Uncle Tad opening the windows in the
room where the sick man had been. And they<span id="Page_44" title="[Pg 44]"></span>
could look in and see that Mr. Pott was no
longer on the couch.</p>
<p class="calibre2">“Where’s he gone?” cried Bunny.
“Where’s Mr. Pott?”</p>
<p class="calibre2">“He has gone away,” said Mrs. Brown.
“Dr. Rudd came and found that the poor man
was much worse, so he decided to send him to
the hospital. He can be better taken care of
there than here. They took him to the hospital
while you were at the store.”</p>
<p class="calibre2">“Oh!” murmured Bunny Brown. After a
moment he asked: “Could we go to the hospital
to see him?”</p>
<p class="calibre2">“Some time, I guess—maybe,” answered
Mrs. Brown. But she was so busy that she
hardly knew what she was saying.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0007.vue?15f2e528